import React, { Component } from 'react'
import { withRouter } from 'react-router-dom'
import {
  HelpBlock,
  FormGroup,
  FormControl,
  ControlLabel,
  InputGroup,
} from 'react-bootstrap'
import {
  AuthenticationDetails,
  CognitoUserPool,
  CognitoUserAttribute,
  CognitoUser,
} from 'amazon-cognito-identity-js'
import axios from 'axios'
import Modal from 'antd/lib/modal'
import debounce from 'throttle-debounce/debounce'
import LoaderButton from '../components/LoaderButton'
import config from '../config.js'
import './Signup.css'


class Signup extends Component {
  constructor(props) {
    super(props);

    const confirmUsername = urlParam('confirmUser');
    const newUser = confirmUsername ?
      new CognitoUser({
        Username : confirmUsername,
        Pool : new CognitoUserPool({
          UserPoolId: config.cognito.USER_POOL_ID,
          ClientId: config.cognito.APP_CLIENT_ID
        })
      }): null;

    this.state = {
      isLoading: false,
      username: '',
      phoneNum: '',
      password: '',
      confirmPassword: '',
      confirmationCode: '',
      newUser,
      invitationCode: '',
      isChecking: false,
      isInvitationCodeValid: false,
      isChecked: false,
      isVerficationSuccess: false,
    };
  }

  validateForm() {
    return this.state.username.length > 0
      && this.state.password.length > 0
      && this.state.password === this.state.confirmPassword
      && this.state.phoneNum.length > 6
  }

  getPhoneNumErrorMsg(){
    if( !this.state.phoneNum.startsWith('+65') ){
      return "Phone number must be start with +65"
    }
    if( this.state.phoneNum.length < 10  ){
      return "Incorrect phone number"
    }
  }

  validateConfirmationForm() {
    return this.state.confirmationCode.length > 0;
  }

  handleChange = (event) => {
    this.setState({
      [event.target.id]: event.target.value
    });

    if(event.target.id==='invitationCode'){
      this.setState({
        isChecked: false,
      })
      if( //!this.state.isChecking &&
          event.target.value.length > 1
      ){
        this.checkInvitationCodeTriggeredByInput();
      }
    }
  }

  checkInvitationCodeTriggeredByInput = debounce(300, false, () => {
    this.checkInvitationCode(this.state.invitationCode)
  })

  checkInvitationCode = async (invitationCode) =>{

    this.setState({ isChecking: true });
    try {
      const url = `${config.apiGateway.URL}invitationcode/${invitationCode}/action/checkValid`
      await axios.get(url).then( (result)=>{
        console.dir(result)
        this.setState({
          isInvitationCodeValid: (result.data && result.data.isValid === true),
          isChecked: true,
        })

        if(result.data && !result.data.isValid){
          Modal.error({
            okText: 'OK',
            title: 'Error',
            content:  <div style={{marginBottom:-20}}>
                        {result.data.message ?
                          result.data.message
                          : 'Error, server return error without further information ' }
                      </div>,
            onOk: ()=>{
              // this.setState({
              //   ...this.stateInit,
              // })
              // window.location.href = '/#page-top'
            }
         })
        }
      })
      .catch( (err)=> {
        console.warn(err);
        this.setState({
          isInvitationCodeValid: false,
          isChecked: true,
        })

        // Modal.error({
        //   okText: 'OK',
        //   title: 'Error',
        //   content:  <div style={{marginBottom:-20}}>
        //               {err.message ?
        //                 err.message
        //                 :err.toString() }
        //             </div>,
        //   onOk: ()=>{
        //   }
        // })
      });
    }
    catch(e) {
      console.error(e)
      Modal.error({
        okText: 'OK',
        title: 'Error',
        content:  <div style={{marginBottom:-20}}>
                    {e.message? e.message: e.toString() }
                  </div>,
        onOk: ()=>{
        }
     })
    }
    this.setState({ isChecking: false });
  }


  handleSubmit = async (event) => {
    event.preventDefault();

    this.setState({ isLoading: true });

    try {
      const newUser = await this.signup(
        this.state.username,
        this.state.password,
        this.state.phoneNum,
        this.state.invitationCode);

      this.setState({
        newUser: newUser
      });
    }
    catch(e) {
      console.dir(e)
      Modal.error({
        okText: 'OK',
        title: 'Error',
        content:  <div style={{marginBottom:-20}}>
                    {e.message? e.message: e.toString() }
                  </div>,
        onOk: ()=>{
        }
     })
    }

    this.setState({ isLoading: false });
  }

  handleConfirmationSubmit = async (event) => {
    event.preventDefault();

    this.setState({ isLoading: true });
    try {
      const resConfirm = await this.confirm(this.state.newUser, this.state.confirmationCode);

      console.dir(resConfirm)
      if( resConfirm === 'SUCCESS'){
        this.setState({
          isVerficationSuccess: true,
        })
      }
      // const userToken = await this.authenticate(
      //   this.state.newUser,
      //   this.state.username,
      //   this.state.password
      // );
      // if(userToken){
      //   this.setState({
      //     isVerficationSuccess: true,
      //   })
      // }
      //this.props.updateUserToken(userToken);
      // this.props.history.push('/');
    }
    catch(e) {
      console.dir(e)
      Modal.error({
        okText: 'OK',
        title: 'Error',
        content:  <div style={{marginBottom:-20}}>
                    {e.message? e.message: e.toString() }
                  </div>,
        onOk: ()=>{
        }
      })
      this.setState({ isLoading: false });
    }

  }

  signup(username, password, phoneNum, invitationCode) {
    const userPool = new CognitoUserPool({
      UserPoolId: config.cognito.USER_POOL_ID,
      ClientId: config.cognito.APP_CLIENT_ID
    });
    const attributeEmail = new CognitoUserAttribute({ Name : 'email', Value : username });
    const attributePhoneNum = new CognitoUserAttribute({ Name : 'phone_number', Value : `+65${phoneNum}` });
    const validationData = [{ Name: 'invitationCode', Value: invitationCode}]
    return new Promise((resolve, reject) => (
      userPool.signUp(username, password, [attributeEmail, attributePhoneNum], validationData, (err, result) => {
        if (err) {
          reject(err);
          return;
        }
        resolve(result.user);
      })
    ));
  }

  confirm(user, confirmationCode) {
    return new Promise((resolve, reject) => (
      user.confirmRegistration(confirmationCode, true, function(err, result) {
        if (err) {
          reject(err);
          return;
        }
        resolve(result);
      })
    ));
  }

  authenticate(user, username, password) {
    const authenticationData = {
      Username: username,
      Password: password
    };
    const authenticationDetails = new AuthenticationDetails(authenticationData);

    return new Promise((resolve, reject) => (
      user.authenticateUser(authenticationDetails, {
        onSuccess: (result) => resolve(result.getIdToken().getJwtToken()),
        onFailure: (err) => reject(err),
      })
    ));
  }

  renderConfirmationForm() {
    return (
      <div>
        {this.state.isVerficationSuccess ?
          <div>
            <h5 style={{color:'black'}}>Congratulations!</h5>
            <div style={{marginTop:20, marginBottom:5, color:'green'}}>Your account activated!</div>
            <LoaderButton
              bsSize='small'
              style={{backgroundColor:'gold', opacity:1.0}}
              text="Login to your Dashboard "
              onClick={()=>{ window.open('https://rkboard.retailknack.com')}}
              loadingText="Verifying…" />
          </div>
          :
          <form onSubmit={this.handleConfirmationSubmit} >
            <FormGroup controlId="confirmationCode" bsSize="large">
              <ControlLabel>Confirmation Code</ControlLabel>
              <FormControl style={{
                  height: 30
                }}
                autoFocus
                type="tel"
                value={this.state.confirmationCode}
                onChange={this.handleChange} />
              <HelpBlock>Please check your email for the confirmation code.</HelpBlock>
            </FormGroup>
            <LoaderButton
              block
              style={{backgroundColor:'gold', opacity:1.0}}
              disabled={ ! this.validateConfirmationForm() }
              type="submit"
              isLoading={this.state.isLoading}
              text="Verify"
              loadingText="Verifying…" />
          </form>
        }

      </div>
    );
  }

  renderForm() {
    return (
      <form onSubmit={this.handleSubmit}>
          <FormGroup controlId="invitationCode" bsSize="large" style={{
              textAlign:'left',
              marginBottom:5
            }} >

            <div className="row">

              <div className="col-lg-12">
                <ControlLabel >Invitation Code:</ControlLabel>
                <br/>
              </div>
            </div>

            <div className="row">

              <div className="col-lg-6">
                <FormControl style={{
                    //width:140,
                    height:36,
                    padding:15,
                    marginBottom: 8,
                  }}
                  autoFocus readOnly={this.state.isInvitationCodeValid}
                  type="text"
                  value={this.state.invitationCode}
                  onChange={this.handleChange}
                  />
                {
                  ( this.state.isInvitationCodeValid &&
                  <img src="/img-customize/yes-green.svg" alt='' style={{width:20,
                      position:'absolute',right: 20, top: 8,
                      zIndex: 2,
                    }}></img> )
                    ||  <img src="/img-customize/sign.svg" alt='' style={{width:20,
                          position:'absolute',right: 20,  top: 8,
                          opacity: `${this.state.isChecked?1.0:(this.state.isChecking?0.0:0.0)}`,
                          zIndex: 2,
                          }}></img>
                }
              </div>

              <div className="col-lg-6">
                <LoaderButton className="btn"  style={{
                    width: 165,
                    height: 36,
                    //position: 'relative', top:-32, left:160,
                    borderColor: '#fed136',
                    backgroundColor: '#fed136',
                    opacity: 1.0,
                    fontFamily: 'Montserrat',
                    fontSize: 14,
                    marginBottom: 8,
                  }}
                  disabled={this.state.invitationCode.length<1 || this.state.isChecking || this.state.isInvitationCodeValid }
                  isLoading={this.state.isChecking}
                  onClick={()=>{this.checkInvitationCode(this.state.invitationCode)}}
                  text="Check"
                  loadingText="Checking..." />
              </div>

          </div>
        </FormGroup>

        { (this.state.isInvitationCodeValid &&
            <div>
              <FormGroup controlId="username" bsSize="large" style={{textAlign:'left', marginBottom:5}}>
                <ControlLabel >Email</ControlLabel>
                <FormControl style={{height:40}}
                  autoFocus
                  type="email"
                  value={this.state.username}
                  onChange={this.handleChange} />
              </FormGroup>
              <FormGroup controlId="password" bsSize="large" style={{textAlign:'left', marginBottom:5}}>
                <ControlLabel>Password</ControlLabel>
                <FormControl style={{height:40}}
                  value={this.state.password}
                  onChange={this.handleChange}
                  type="password" />
              </FormGroup>
              <FormGroup controlId="confirmPassword" bsSize="large" style={{textAlign:'left', marginBottom:5}}>
                <ControlLabel>Confirm Password</ControlLabel>
                <FormControl style={{height:40}}
                  value={this.state.confirmPassword}
                  onChange={this.handleChange}
                  type="password" />
              </FormGroup>
              <FormGroup controlId="phoneNum" bsSize="large"
                style={{
                  textAlign:'left',
                  marginBottom:20,
                }}>
                <ControlLabel >Phone Number <text>{}</text></ControlLabel>

                <InputGroup style={{padding:0,
                height:40,}}>
                  <InputGroup.Addon style={{
                      padding:'0px 10px 0px 10px',
                      height:38}}>
                    +65
                  </InputGroup.Addon>

                  <FormControl  style={{height: 40}}
                    type="number"
                    value={this.state.phoneNum}
                    onChange={this.handleChange} />
                </InputGroup>
              </FormGroup>
              <div className="row">

                <div className="col-lg-12">
                <LoaderButton
                  block
                  disabled={ ! this.validateForm() }
                  type="submit"
                  isLoading={this.state.isLoading}
                  style={{
                    backgroundColor:'gold',
                    opacity: 1.0,
                    height: 40,
                    fontSize: 18,
                    fontFamily: 'Montserrat',
                  }}
                  text="Sign Up"
                  loadingText="Signing up…" />
                  </div>
              </div>
            </div>
          ) || <div style={{height:285}} />
      }
      </form>
    );
  }


  render() {
    return (

      <section id="contact" style={{
        backgroundColor: '#EEEEEE',
        backgroundImage: 'none',
        paddingTop: 100,
        marginTop: -30,
      }}>
        <div className="container" style={{
            paddingTop: 80,
            paddingBottom: 100,
            backgroundRepeat: 'no-repeat',
            backgroundPosition: 'top center',
            backgroundSize: 450,
            backgroundImage: `url("/img-customize/singapore-map.png")`,
          }}>
          <div className="row" style={{
          }}>
            <div className="col-lg-4"/>
            <div className="col-lg-4 text-center">
              <h2 className="section-heading" style={{
                  color:'#333333',
                  fontWeight:700,}}>
                 Register
              </h2>
              <h3 style={{marginTop: 5, marginBottom: 5,
                  color:'#666666',
                  fontWeight:'bold',
                  fontSize: 24,
                }}>(Invited)
              </h3>
              <br/>
              { this.state.newUser === null
                ? this.renderForm()
                : this.renderConfirmationForm()
              }
            </div>
            <div className="col-lg-4"/>
          </div>
      </div>
    </section>

    );
  }
}

const urlParam = (name) => {
  let reg = new RegExp(`(^|&)${name}=([^&]*)(&|$)`, 'i')
  let r = window.location.search.substr(1).match(reg)
  if (r != null) return decodeURI(r[2])
  return null
}

export default withRouter(Signup);



// WEBPACK FOOTER //
// ./src/containers/Signup.js